import React, { useState } from "react";
import { AiFillGithub, AiFillEye } from "react-icons/ai";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import ProjectModal from "../../components/ProjectModal";
import works from "../../data/worksData";
import "./Work.scss";

const truncateDescription = (text, maxWords = 64) => {
  if (!text) return "";
  const words = text.split(" ");
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(" ") + "...";
};

const Work = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewDetails = (work) => {
    setSelectedProject(work);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  };

  return (
    <div className="work-container">
      <h2 className="heading-1 color-primary-text">
        <span>Side</span> <span className="color-primary">Quests</span>
      </h2>

      <div className="work-timeline">
        {works.map((work, index) => (
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className="work-item"
            key={index}
          >
            <div className="work-item-content">
              <div className="work-item-image">
                <img src={work.imgUrl} alt={work.title} />
                <div className="work-item-overlay">
                  <div className="work-item-actions">
                    {work.projectLink && (
                      <a
                        href={work.projectLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="work-action-btn"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <AiFillEye />
                      </a>
                    )}
                    {work.codeLink && (
                      <a
                        href={work.codeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="work-action-btn"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <AiFillGithub />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div className="work-item-info">
                <div className="work-item-header">
                  <div className="work-item-title-row">
                    <h3 className="work-item-title">{work.title}</h3>
                    <button
                      className="work-details-btn"
                      onClick={() => handleViewDetails(work)}
                    >
                      View Details <span className="work-details-arrow">→</span>
                    </button>
                  </div>
                  <div className="work-item-tags">
                    {work.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="work-tag">{tag}</span>
                    ))}
                  </div>
                </div>
                <p className="work-item-description">{truncateDescription(work.description, 64)}</p>
                {work.technologies && work.technologies.length > 0 && (
                  <div className="work-item-tech">
                    {work.technologies.slice(0, 4).map((tech, techIndex) => (
                      <span key={techIndex} className="work-tech-badge">{tech}</span>
                    ))}
                    {work.technologies.length > 4 && (
                      <span className="work-tech-more">+{work.technologies.length - 4}</span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <ProjectModal
        project={selectedProject}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default AppWrap(
  MotionWrap(Work, "flex full-width flex-col"),
  "work",
  "bg-color-primary-bg"
);
